<mat-form-field>

  <mat-label>{{label}}</mat-label>

  <input matInput [type]="type" [formControl]="fieldCtrl" [errorStateMatcher]="matcher"
    [required]="required ? 'required' : false" [readonly]="!editing">

  @if (!editing && !saving) {

  <button mat-icon-button matSuffix (click)="edit()">
    <mat-icon>mode_edit</mat-icon>
  </button>

  }
  @else if (editing) {

  <ng-container matSuffix>

    <button mat-icon-button [disabled]="!saveEnabled" (click)="save()">
      <mat-icon>done</mat-icon>
    </button>
    <button mat-icon-button (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>

  </ng-container>

  }

  @if (saving) {

  <span matSuffix class="saving">{{msg.io.saving}}...</span>

  }

  @if (fieldCtrl.invalid) {

  <mat-error>{{errMsg}}</mat-error>

  }

</mat-form-field>